export enum DeviceDGAModalTab {
  General = 'general',
  Submissions = 'submissions',
  MaxFlow = 'max-flow',
  Notifications = 'notifications',
}
